import React from "react";

function TeachingMode() {
  return (
    <div className="container my-5">
      <h2 className="text-center text-primary">📚 Mode of Teaching & Notes</h2>

      <div className="card p-4 shadow-lg">
        <h3>📌 Mode of Teaching:</h3>
        <p>✅ The course will be conducted **Online** via Zoom/Google Meet.</p>

        <h3>📚 Notes & Study Materials:</h3>
        <p>✅ Daily notes and recordings will be shared for easy revision.</p>

        <h3>💻 Practical Sessions:</h3>
        <p>✅ Hands-on coding sessions, assignments, and real-world applications.</p>

        <h3>📅 Course Duration:</h3>
        <p>✅ The training will last for **3 months**, covering all topics in depth.</p>

        <h3>🛠 Final Project:</h3>
        <p>
          ✅ At the end of the course, students will work on a **real-world backend project**  
          covering Java, Spring Boot, Microservices, and more.
        </p>
      </div>
    </div>
  );
}

export default TeachingMode;
